"use client"

import { ProjectDetailPage } from "@/components/project-pages/project-detail-page"
import { SiteFooter } from "@/components/site-footer"
import { SiteHeader } from "@/components/site-header"
import type { ProjectDetail } from "@/lib/project-details"
import type { Project } from "@/lib/projects"

export function ProjectPageClient({ project, detail }: { project: Project; detail: ProjectDetail }) {
  return (
    <>
      <SiteHeader />
      <main>
        <ProjectDetailPage project={project} detail={detail} />
      </main>
      <SiteFooter />
    </>
  )
}
